import Loadable from "react-loadable";
import Loading from "./common/screens/LoadingScreen";

const ServiceScreen = Loadable({
  loader: () => import("./Screens/ServiceScreen"),
  loading: Loading,
});

const UserGridScreen = Loadable({
  loader: () => import("./common/screens/UserGridScreen"),
  loading: Loading,
});

const UserEditScreen = Loadable({
  loader: () => import("./Screens/UserEditScreen"),
  loading: Loading,
});

const MyUserEditScreen = Loadable({
  loader: () => import("./Screens/MyUserEditScreen"),
  loading: Loading,
});

const MeasurementScreen = Loadable({
  loader: () => import("./Screens/MeasurementScreen"),
  loading: Loading,
});

const AgreementScreen = Loadable({
  loader: () => import("./Screens/AgreementScreen"),
  loading: Loading,
});

export default [
  { path: "/account", name: "MyAccount", Component: MyUserEditScreen },
  { path: "/user", name: "Users", Component: UserGridScreen },
  { path: "/user/:id", name: "Edit", Component: UserEditScreen },
  { path: "/service", name: "Service", Component: ServiceScreen },
  { path: "/agreement", name: "Agreements", Component: AgreementScreen },
  {
    path: "/agreement/:id",
    name: "UserAgreements",
    Component: AgreementScreen,
  },
  {
    path: "/agreement/measurement/:userId/:agreementId",
    name: "Measurements",
    Component: MeasurementScreen,
  },
];
